import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';
import { MessageType, ColorQuality, DeviceScale } from 'app/modules/remote-control-ng/definitions';

enum RestartMessageFlags {
    FULLSCREEN = 1,
    SCALE = 4,
    IMAGE_QUALITY = 8,
}

/** PC_RESTART MessageType*/
export class RestartMessage extends BaseMessage {
    public colorQuality: number = ColorQuality.ColorQuality16Bpp;
    public imageQuality: number;
    public scale: number;
    public monitorId = 0;
    public forceRestart: boolean;

    constructor(options?: Partial<RestartMessage>) {
        super();
        this.header.command = MessageType.PC_RESTART;
        if (options) Object.assign(this, options);
    }

    public serializeBody(buffer: MemoryBuffer): void {
        // Flags
        buffer.writeUInt8(0);
        buffer.writeUInt8(0);
        buffer.writeUInt8(this.colorQuality);
        buffer.writeUInt8(0);

        // Monitor
        buffer.writeInt32BE(this.monitorId);

        // Flags (1 === fullscreen, 4 === scale, 8 === quality)
        // if (this.imageQuality === undefined) {
        //     buffer.writeInt32BE(RestartMessageFlags.SCALE);
        // } else {
        //     // eslint-disable-next-line no-bitwise
            // buffer.writeInt32BE(RestartMessageFlags.SCALE | RestartMessageFlags.IMAGE_QUALITY);
        // }
        // From createRestartMessage() in nxt-remote-control.messaging.service.ts
        let flags = this.forceRestart || this.scale ? RestartMessageFlags.FULLSCREEN : 0;
        if (this.scale) {
            flags |= RestartMessageFlags.SCALE;
        }
        if (this.imageQuality) {
            flags |= RestartMessageFlags.IMAGE_QUALITY;
        }
        buffer.writeInt32BE(flags);

        // Scale
        if (this.scale > DeviceScale.Scale100) {
            this.scale = DeviceScale.Scale100;
        }

        // eslint-disable-next-line no-bitwise
        buffer.writeInt32BE(this.scale | 0);

        // Quality
        if (this.imageQuality !== undefined) {
            buffer.writeInt32BE(this.imageQuality);
        }
    }
}
